import { Button } from 'components/Button/Button';
import messages from 'components/ErrorPage/messages';
import usePageConfig from 'hooks/usePageConfig';
import appHelpers from 'utils/app-urls';

const cdnURL = appHelpers.getCDNUrl();

export const Error = () => {
  const pageConfig = usePageConfig();

  const errorImg = `${cdnURL}assets/navigation/error-frown.svg`;
  // TODO: Use language from store
  const errorMessages = messages.en.error;
  const goToPortfolio = () => window.location.replace('/');

  return (
    <div className="relative w-full mt-8">
      <div className="w-full flex items-center justify-center">
        <div className="flex flex-col items-center justify-center h-screen">
          <img className="w-full max-w-[180px]" src={errorImg} alt="404" />
          <div className="font-semibold text-header-text text-3xl md:text-4xl leading-10 pt-8">
            {errorMessages.errorHeading}
          </div>

          <div className="pt-5 text-header-text text-center">
            <div>
              {errorMessages.supportMessagePreLink}{' '}
              <span className="font-semibold">
                <a href={`mailto:${pageConfig?.app?.supportEmail}`}>
                  {pageConfig?.app?.supportEmail}
                </a>
              </span>
            </div>
          </div>

          <Button
            primary
            main
            onClick={() => goToPortfolio()}
            className="mt-8 continue">
            {errorMessages.buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};
